import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import EventEmitter from 'eventemitter3';
import { isEqual } from 'lodash';
export var TileStyleService = /*#__PURE__*/function (_EventEmitter) {
  _inherits(TileStyleService, _EventEmitter);

  var _super = _createSuper(TileStyleService);

  function TileStyleService() {
    var _this;

    _classCallCheck(this, TileStyleService);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "checkConfigList", []);

    _this.cacheConfig = new Map();
    return _this;
  }

  _createClass(TileStyleService, [{
    key: "setConfig",
    value: function setConfig(key, value) {
      if (!this.checkConfigList.includes(key)) {
        this.checkConfigList.push(key);
      }

      this.cacheConfig.set(key, value);
    }
  }, {
    key: "removeConfig",
    value: function removeConfig(key) {
      var configIndex = this.checkConfigList.indexOf(key);

      if (configIndex > -1) {
        this.cacheConfig.delete(key);
        this.checkConfigList.splice(configIndex, 1);
      }
    }
  }, {
    key: "checkConfig",
    value: function checkConfig(layer) {
      var _this2 = this;

      if (!layer.inited) {
        return;
      }

      var layerConfig = layer.getLayerConfig();
      var updateConfigs = [];
      this.checkConfigList.map(function (key) {
        var cacheConfig = _this2.cacheConfig.get(key);

        var currentConfig;

        if (['color', 'size', 'shape'].includes(key)) {
          var _layer$getAttribute;

          currentConfig = (_layer$getAttribute = layer.getAttribute(key)) === null || _layer$getAttribute === void 0 ? void 0 : _layer$getAttribute.scale;
        } else {
          if (!(key in layerConfig)) {
            return;
          } // @ts-ignore


          currentConfig = layerConfig[key];
        }

        if (!isEqual(cacheConfig, currentConfig)) {
          updateConfigs.push(key);

          _this2.setConfig(key, currentConfig);
        }
      });

      if (updateConfigs.length > 0) {
        console.warn('tile config cache update!', updateConfigs);
        this.emit('updateConfig', updateConfigs);
      }
    }
  }, {
    key: "getAttributeScale",
    value: function getAttributeScale(layer, name) {
      var attribute = layer.getAttribute(name);
      var scaleValue = {
        field: undefined,
        values: undefined,
        callback: undefined
      };

      if (attribute && attribute.scale) {
        var _attribute$scale = attribute.scale,
            field = _attribute$scale.field,
            values = _attribute$scale.values,
            callback = _attribute$scale.callback;
        scaleValue.field = field;
        scaleValue.values = values;
        scaleValue.callback = callback;
      }

      return scaleValue;
    }
  }]);

  return TileStyleService;
}(EventEmitter);